
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-72e447ea\",\"scoped\":true,\"hasInlineConfig\":false}!@../../../static/css/website.css")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./privacyPolicy.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-72e447ea\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./privacyPolicy.vue"),
  /* scopeId */
  "data-v-72e447ea",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/views/ecommerce/privacyPolicy.vue
// module id = 1769
// module chunks = 0